export const DataDictionaryFeaturePermissions = {
  MayViewAppDataDictionaries: 'DD-MVADD',
  MayActivateAppDataDictionaries: 'DD-MAADD',
  MayDownloadAppDataDictionaries: 'DD-MDADD',
  MayViewDiffAppDataDictionaries: 'DD-MVDADD',
};
